import { api } from "../App";
import {
  SET_VIDEO_RECORDS_LIST,
  SET_VIDEO_RECORDS_LOADING,
  SET_VIDEO_RECORDS_FILTERS,
  SET_VIDEO_LOOK_LOADING,
  SET_VIDEO_LOOK_TEACHERS,
  SET_VIDEO_LOOK_COURSES,
  SET_VIDEO_LOOK_GROUPS,
  SET_VIDEO_LOOK_LIST,
  SET_VIDEO_LOOK_LESSON_TIMES,
  SET_VIDEO_LOOK_CAMERA
} from "./types";

export const getVideoRecords = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_VIDEO_RECORDS_LOADING, payload: true });

    const params = new URLSearchParams();
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.subject_id) params.append('subject_id', filters.subject_id);
    if (filters.teacher_id) params.append('teacher_id', filters.teacher_id);
    if (filters.class_id) params.append('class_id', filters.class_id);

    const queryString = params.toString();
    const url = queryString ? `/xp_video_records?${queryString}` : '/xp_video_records';

    const { data } = await api.get(url);
    dispatch({ type: SET_VIDEO_RECORDS_LIST, payload: data });
    dispatch({ type: SET_VIDEO_RECORDS_FILTERS, payload: filters });
  } catch (ERR) {
    console.error('Error fetching video records:', ERR);
  } finally {
    dispatch({ type: SET_VIDEO_RECORDS_LOADING, payload: false });
  }
};

export const getVideoRecordUrl = (recordId) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_video_records/${recordId}/url`);
    return data.url;
  } catch (ERR) {
    console.error('Error fetching video record URL:', ERR);
    throw ERR;
  }
};

// GET /api/video_look/teachers - Список учителей для фильтра
export const getVideoLookTeachers = (data) => async (dispatch) => {
  const urlParams = new URLSearchParams(data).toString();
  try {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: true });
    const { data } = await api.get(`/video_look/teachers?${urlParams}`);
    dispatch({ type: SET_VIDEO_LOOK_TEACHERS, payload: data });
  } catch (ERR) {
    console.error('Error fetching video look teachers:', ERR);
  } finally {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: false });
  }
};

// GET /api/video_look/courses - Список предметов для фильтра
export const getVideoLookCourses = (data) => async (dispatch) => {
  const urlParams = new URLSearchParams(data).toString();
  try {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: true });
    const { data } = await api.get(`/video_look/courses?${urlParams}`);
    dispatch({ type: SET_VIDEO_LOOK_COURSES, payload: data });
  } catch (ERR) {
    console.error('Error fetching video look courses:', ERR);
  } finally {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: false });
  }
};

// GET /api/video_look/groups - Список классов/групп для фильтра
export const getVideoLookGroups = (data) => async (dispatch) => {
  const urlParams = new URLSearchParams(data).toString();
  try {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: true });
    const { data } = await api.get(`/video_look/groups?${urlParams}`);
    dispatch({ type: SET_VIDEO_LOOK_GROUPS, payload: data });
  } catch (ERR) {
    console.error('Error fetching video look groups:', ERR);
  } finally {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: false });
  }
};

// GET /api/video_look - Список уроков с привязкой к видеокамерам
export const getVideoLookList = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: true });

    const params = new URLSearchParams();
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.subject_id) params.append('subject_id', filters.subject_id);
    if (filters.teacher_id) params.append('teacher_id', filters.teacher_id);
    if (filters.class_id) params.append('class_id', filters.class_id);

    const queryString = params.toString();
    const url = queryString ? `/video_look?${queryString}` : '/video_look';

    const { data } = await api.get(url);
    dispatch({ type: SET_VIDEO_LOOK_LIST, payload: data });
  } catch (ERR) {
    console.error('Error fetching video look list:', ERR);
  } finally {
    dispatch({ type: SET_VIDEO_LOOK_LOADING, payload: false });
  }
};

// GET /api/video_look/lesson_times/{period_id} - Время начала/окончания урока по ID периода
export const getVideoLookLessonTimes = (periodId) => async (dispatch) => {
  try {
    const { data } = await api.get(`/video_look/lesson_times/${periodId}`);
    dispatch({ type: SET_VIDEO_LOOK_LESSON_TIMES, payload: data });
    return data;
  } catch (ERR) {
    console.error('Error fetching video look lesson times:', ERR);
    throw ERR;
  }
};

// GET /api/video_look/camera/{camid} - Детали камеры для воспроизведения видео
export const getVideoLookCamera = (camId) => async (dispatch) => {
  try {
    const { data } = await api.get(`/video_look/camera/${camId}`);
    dispatch({ type: SET_VIDEO_LOOK_CAMERA, payload: data });
    return data;
  } catch (ERR) {
    console.error('Error fetching video look camera:', ERR);
    throw ERR;
  }
};
